export default __webpack_public_path__ + "static/media/flatout-green.b5d110bc.jpg";